import { Component, Input, OnInit } from '@angular/core';
import ICombinedSolrStatistic = ZoningAPI.ICombinedSolrStatistic;
import * as _ from 'lodash';

@Component({
    standalone: false,
    selector: 'app-solr-operations-status',
    templateUrl: './solr-operations-status.component.html',
    styleUrls: ['./solr-operations-status.component.scss']
})
export class SolrOperationsStatusComponent implements OnInit {
    @Input()
    data: ICombinedSolrStatistic;

    constructor() {}

    get isSuccessfull(): boolean {
        return !_.get(this.data, 'addGroupIdsFailed') && !_.get(this.data, 'removeGroupIdsFailed');
    }

    ngOnInit(): void {}
}
